import React from 'react'
import { Box, Container, Link, Typography } from '@material-ui/core'
import { useIntl } from 'gatsby-plugin-intl'
import { ArrowIcon, DocumentIcon, HeroSection } from '../../components'
import { useStyles } from './financialStatements.styles'
import { baseURL, financialStatementsData } from './financialStatements.data'

const StatementsPage = ({ data = {}, location, t }) => {
  const { hero } = data
  const { locale } = useIntl()

  const styles = useStyles()

  return (
    <main>
      <HeroSection {...hero} t={t} />
      <Container maxWidth="lg" className={styles.mainFormContainer}>
        <Container maxWidth="md">
          <Box className={styles.financialYearContainer}>
            {Object.keys(financialStatementsData)
              .reverse()
              .map((e) => {
                const year = e
                const financialReports = financialStatementsData[e]
                return (
                  <>
                    <Typography variant="h3">{year}</Typography>
                    <Box className={styles.financialReportLinksContainer}>
                      {financialReports.map((quarters) => {
                        return (
                          <Box
                            className={styles.financialReportLink}
                            key={quarters.name}
                          >
                            <Link target="_blank" href={baseURL + quarters.url}>
                              <Box className={styles.financialReportName}>
                                <DocumentIcon />
                                <Typography variant="h6">
                                  {quarters.name}
                                </Typography>
                              </Box>
                              <ArrowIcon
                                direction={'forward'}
                                locale={locale}
                              />
                            </Link>
                          </Box>
                        )
                      })}
                    </Box>
                  </>
                )
              })}
          </Box>
        </Container>
      </Container>
    </main>
  )
}

export default StatementsPage
